/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable @typescript-eslint/naming-convention */

export const textVariant = {
  display: {
    huge: {
      fontFamily: "'Nunito Sans',sans-serif;",
      fontWeight: 800,
      lineHeight: '48px',
      fontSize: '42px',
      letterSpacing: '-0.003em',
    },
    large: {
      fontFamily: "'Nunito Sans',sans-serif;",
      fontWeight: 800,
      lineHeight: '42px',
      fontSize: '36px',
      letterSpacing: '-0.003em',
    },
    small: {
      fontFamily: "'Nunito Sans',sans-serif;",
      fontWeight: 800,
      lineHeight: '36px',
      fontSize: '30px',
      letterSpacing: '-0.003em',
    },
    tiny: {
      fontFamily: "'Nunito Sans',sans-serif;",
      fontWeight: 800,
      lineHeight: '30px',
      fontSize: '24px',
      letterSpacing: '-0.003em',
    },
  },
  headline: {
    large: {
      fontFamily: "'Nunito Sans',sans-serif;",
      fontWeight: 800,
      lineHeight: '28px',
      fontSize: '20px',
      letterSpacing: '-0.002em',
    },
    default: {
      fontFamily: "'Nunito Sans',sans-serif;",
      fontWeight: 800,
      lineHeight: '26px',
      fontSize: '18px',
      letterSpacing: '0.002em',
    },
    small: {
      fontFamily: "'Nunito Sans',sans-serif;",
      fontWeight: 800,
      lineHeight: '24px',
      fontSize: '16px',
      letterSpacing: '-0.002em',
    },
    tiny: {
      fontFamily: "'Nunito Sans',sans-serif;",
      fontWeight: 700,
      lineHeight: '20px',
      fontSize: '14px',
      letterSpacing: '0.001em',
    },
    superTiny: {
      fontFamily: "'Nunito Sans',sans-serif;",
      fontWeight: 700,
      lineHeight: '16px',
      fontSize: '12px',
      letterSpacing: '0.003em',
    },
  },
  body: {
    large: {
      fontFamily: "'Nunito Sans',sans-serif;",
      fontWeight: 600,
      lineHeight: '24px',
      fontSize: '18px',
      letterSpacing: '0.002em',
    },
    largeStrong: {
      fontFamily: "'Nunito Sans',sans-serif;",
      fontWeight: 700,
      lineHeight: '24px',
      fontSize: '18px',
      letterSpacing: '0.002em',
    },
    default: {
      fontFamily: "'Nunito Sans',sans-serif;",
      fontWeight: 600,
      lineHeight: '22px',
      fontSize: '16px',
      letterSpacing: '0em',
    },
    defaultStrong: {
      fontFamily: "'Nunito Sans',sans-serif;",
      fontWeight: 700,
      lineHeight: '22px',
      fontSize: '16px',
      letterSpacing: '0em',
    },
    small: {
      fontFamily: "'Nunito Sans',sans-serif;",
      fontWeight: 600,
      lineHeight: '20px',
      fontSize: '14px',
      letterSpacing: '0.001em',
    },
    smallStrong: {
      fontFamily: "'Nunito Sans',sans-serif;",
      fontWeight: 700,
      lineHeight: '20px',
      fontSize: '14px',
      letterSpacing: '0.001em',
    },
    tiny: {
      fontFamily: "'Nunito Sans',sans-serif;",
      fontWeight: 600,
      lineHeight: '16px',
      fontSize: '12px',
      letterSpacing: '0.003em',
    },
    tinyStrong: {
      fontFamily: "'Nunito Sans',sans-serif;",
      fontWeight: 700,
      lineHeight: '16px',
      fontSize: '12px',
      letterSpacing: '0.003em',
    },
  },
  paragraph: {
    large: {
      fontFamily: "'Nunito Sans',sans-serif;",
      fontWeight: 400,
      lineHeight: '26px',
      fontSize: '18px',
      letterSpacing: '0em',
    },
    default: {
      fontFamily: "'Nunito Sans',sans-serif;",
      fontWeight: 400,
      lineHeight: '24px',
      fontSize: '16px',
      letterSpacing: '0em',
    },
    small: {
      fontFamily: "'Nunito Sans',sans-serif;",
      fontWeight: 400,
      lineHeight: '22px',
      fontSize: '14px',
      letterSpacing: '0em',
    },
    tiny: {
      fontFamily: "'Nunito Sans',sans-serif;",
      fontWeight: 400,
      lineHeight: '18px',
      fontSize: '12px',
      letterSpacing: '0em',
    },
  },
  caption: {
    default: {
      fontFamily: "'Nunito Sans',sans-serif;",
      fontWeight: 400,
      lineHeight: '20px',
      fontSize: '14px',
      letterSpacing: '0em',
    },
    small: {
      fontFamily: "'Nunito Sans',sans-serif;",
      fontWeight: 400,
      lineHeight: '16px',
      fontSize: '12px',
      letterSpacing: '0em',
    },
    tiny: {
      fontFamily: "'Nunito Sans',sans-serif;",
      fontWeight: 400,
      lineHeight: '12px',
      fontSize: '10px',
      letterSpacing: '0em',
    },
    tinyBold: {
      fontFamily: "'Nunito Sans',sans-serif;",
      fontWeight: 700,
      lineHeight: '12px',
      fontSize: '10px',
      letterSpacing: '0em',
    },
  },
}
export type TextVariantType = typeof textVariant
declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    h0: true
    h1: true
    h2: true
    h3: true
    h4: true
    h5: true
    h6: true
    body1: true
    body2: true
    body3: true
    smallRegular: true
    smallBold: true
    button: false
    caption: false
    overline: false
    subtitle1: false
    subtitle2: false
    'display-huge': true
    'display-large': true
    'display-small': true
    'display-tiny': true
    'headline-large': true
    'headline-default': true
    'headline-small': true
    'headline-tiny': true
    'headline-superTiny': true
    'body-large': true
    'body-largeStrong': true
    'body-default': true
    'body-defaultStrong': true
    'body-small': true
    'body-smallStrong': true
    'body-tiny': true
    'body-tinyStrong': true
    'paragraph-large': true
    'paragraph-default': true
    'paragraph-small': true
    'paragraph-tiny': true
    'caption-default': true
    'caption-small': true
    'caption-tiny': true
    'caption-tinyBold': true
  }
}
